import {IResponse} from "../index";
import {AJAX_METHOD, AJAX_TIMEOUT_DURATION} from "../constants";

import * as $ from "jquery";
import pubsub from "../pubsub";
import CacheManager from "./CacheManager";
import {_d, getWebServiceUrl} from "../util/misc";
import {TServiceName} from "../constants/ApiServices";
import {nsRequest} from "./fn";

interface IRequestOptions {
    success?: (data: IResponse | null, textStatus?: string, jqXHR?: JQueryXHR) => any,
    error?: (jqXHR?: JQueryXHR, textStatus?: string, errorThrown?: string) => any
}

export default class Request {

    private cacheManager: CacheManager;

    constructor(cacheManager: CacheManager) {
        this.cacheManager = cacheManager;
    }

    r(serviceName: TServiceName,
      params: any = {},
      options?: IRequestOptions): JQueryXHR | null {

        _d.groupCollapsed("↗", serviceName);
        _d.log(params || "—");
        _d.groupEnd();

        if (nsRequest.abortIfMissingMandatoryToken(serviceName, params)) {
            return null;
        }

        // Return cache instance if it exists.
        let cache = this.cacheManager.getCache(serviceName, params, false);
        if (cache) {
            _d.groupCollapsed("↩", serviceName);
            _d.info(cache || "—");
            _d.groupEnd();
            // make use of any given callback
            if (options && !!options.success) {
                options.success(cache.data);
                return null;
            }
            pubsub.trigger(serviceName + "_success", cache);
            return null;
        }

        return jQuery.ajax({
            cache: false,
            data: params,
            // dataType: "json",
            global: false,
            jsonp: false,
            method: AJAX_METHOD,
            timeout: AJAX_TIMEOUT_DURATION,
            type: AJAX_METHOD,
            url: getWebServiceUrl(serviceName),
            // xhrFields: {
            //     withCredentials: true
            // },
            complete: (jqXHR: JQueryXHR, textStatus: string) => {
                pubsub.trigger(serviceName + "_complete", {
                    jqXHR: jqXHR,
                    textStatus: textStatus
                });
            },
            error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
                if (textStatus == "abort" || errorThrown == "abort") {
                    _d.groupCollapsed("⊗", serviceName);
                    _d.log(jqXHR || "—");
                    _d.log(textStatus || "—");
                    _d.log(errorThrown || "—");
                    _d.groupEnd();
                    // not really an error
                    return;
                }

                _d.groupCollapsed("☠", serviceName);
                _d.log(textStatus || "—");
                _d.log(errorThrown || "—");
                _d.log(jqXHR || "—");
                _d.groupEnd();

                // make use of any given callback
                if (options && !!options.error) {
                    options.error(jqXHR, textStatus, errorThrown);
                }
                // or trigger a service specific error event
                else {
                    pubsub.trigger(serviceName + "_error", {
                        jqXHR: jqXHR,
                        textStatus: textStatus,
                        errorThrown: errorThrown
                    });
                }
                // always trigger a general xhr error event
                pubsub.trigger("xhr_error", {
                    jqXHR: jqXHR,
                    textStatus: textStatus,
                    errorThrown: errorThrown
                });
            },
            success: (response: any, textStatus: string, jqXHR: JQueryXHR) => {

                let parsedResponse: IResponse | null = null;
                let returncode: number | null = null;

                try {
                    if (response.lastIndexOf("null") === (response.length - 4)) {
                        response = response.substring(0, response.length - 4)
                    }
                    parsedResponse = JSON.parse(response);
                    returncode = parseInt(parsedResponse!.returncode);
                } catch (err) {
                    _d.error(err);
                    parsedResponse = null;
                }

                _d.groupCollapsed("↙", serviceName);
                _d.log(parsedResponse || "—");
                _d.groupEnd();

                if (returncode === 1) {
                    pubsub.trigger("not_authenticated");
                    return;
                }

                if (parsedResponse && !returncode) {
                    this.cacheManager.setCache(serviceName, parsedResponse, params);
                }

                // make use of any given callback
                if (options && !!options.success) {
                    options.success(parsedResponse, textStatus, jqXHR);
                    return;
                }
                // or trigger an event
                else {
                    pubsub.trigger(serviceName + "_success", {
                        data: parsedResponse,
                        textStatus: textStatus,
                        jqXHR: jqXHR
                    });
                }
            }
        });
    }
}
